module.exports = __webpack_public_path__ + "static/media/SF_bm_primaerlogo_rogaland_neg.d7541c32.svg";